import * as ng from 'angular';
import * as ASM from './interfaces';
import * as Core from './../core';
import Template = ASM.IContentTemplate;

interface IContentTemplateResource extends ng.resource.IResourceClass<ASM.IContentTemplate> {
    update(contentTemplate: ASM.IContentTemplate): ASM.IContentTemplate;
}

let ContentTemplateResourceFactory = function ($resource: ng.resource.IResourceService, exception: Core.IException,
    logger: Core.ILogger, SiteConfig: Core.ISiteConfigService): IContentTemplateResource {
    return <IContentTemplateResource>$resource(
        SiteConfig.getResourceUri("contentTemplates"),
        { id: '@id' } as any,
        new ContentTemplateResource(SiteConfig) as any
    );
};

ContentTemplateResourceFactory.$inject = ['$resource', 'exception', 'logger', 'SiteConfig'];

class ContentTemplateResource {

    constructor(private SiteConfig: Core.ISiteConfigService) {

    }

    public query: ng.resource.IActionDescriptor = {
        method: 'POST',
        isArray: true,
        params: {
            query: true
        }
    };

    public update: ng.resource.IActionDescriptor = {
        method: 'PUT',
        url: this.SiteConfig.getResourceUri('contentTemplatesWrite')
    };

    public save: ng.resource.IActionDescriptor = {
        method: 'POST',
        url: this.SiteConfig.getResourceUri('contentTemplatesWrite')
    };
}

let ContentTemplate = {
    name: "ContentTemplate",
    factory: ContentTemplateResourceFactory
};

export { ContentTemplate, IContentTemplateResource }
export default ContentTemplate;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/data/content-template.ts